export class CycleCountSaveRequest {
    cycleCountHistoryUidK: number;
    count: number;
    countOperatorC: string;
	partCodeGspnPreffix: string;
	partCodeGspnSuffix: string;
	partCodeGspnBase: string;
	cycleCountTypeC: string;
	partXWarehouseUidK: number;
}
